const BASE_URL = 'https://nft-carbon-server.herokuapp.com/api'
// const BASE_URL = 'http://localhost:8000/api'

export const createLogementApi = async (data) => {
  const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  }
  return await fetch(`${BASE_URL}/logements`, options)
}
